import {ServerModalV3} from "../helpers/modals/ClassBased/ServerModalV3";

// noinspection JSUnusedGlobalSymbols -- Imported via d.ts
class IdeasBoardSelectPostModal extends ServerModalV3 {
	/** @var {IdeasBoardSelectPostModalDefs.Config} */
	config;

	constructor(initialRoute, config) {
		super(initialRoute, config);

		this.config = config;

	}

	init() {
		// Setup select post button
		this.modalContainer.querySelectorAll('.select-post-button').forEach(button => {
			button.addEventListener('click', () => {
				this.hide();
				this.notifySuccessListeners(JSON.parse(button.dataset.post));
			})
		})

		// Set on back event when hiding always
		$(this.modalContainer).on('hide.bs.modal', () => {
			if (this.config.onBackRequest) {
				this.config.onBackRequest();
			}
		})
	}
}

export {IdeasBoardSelectPostModal}
